import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { applySnapshot, getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { generateAddressString } from 'src/utils/address';
import { createAsync } from 'src/utils/asyncModel';
const getBuildingAsync = createAsync(body => {
  return async function getBuilding(options) {
    const resp = await api.Buildings.getBuilding(body, options);
    const updateStore = body.updateStore === undefined ? true : body.updateStore;
    if (updateStore) {
      const _getParent = getParent(this),
        buildings = _getParent.buildings;
      buildings.setBuildingsIdsAfterLoad(resp);
    }
    return resp;
  };
});
const getBuildingsBatchAsync = createAsync(body => {
  return async function getBuildingsBatch(options) {
    const resp = await api.Buildings.getBuildingsBatch(body, options);
    return resp;
  };
});
const Building = types.model('Building', {
  buildingAddress: types.string,
  id: types.string
});
const BuildingsStore = types.model('BuildingsStore', {
  building: types.optional(Building, {
    buildingAddress: 'N/A',
    id: ''
  }),
  getBuildingAsync,
  getBuildingsBatchAsync
}).actions(store => ({
  setBuildingsIdsAfterLoad(data) {
    try {
      applySnapshot(store, _objectSpread(_objectSpread({}, store), {}, {
        building: {
          buildingAddress: generateAddressString(data.response[0].address),
          id: data.response[0].id
        }
      }));
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  resetBuildingsIdsAfterLogout() {
    try {
      store.building = {
        buildingAddress: 'N/A',
        id: ''
      };
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
})).views(store => ({
  get getBuilding() {
    return store.building;
  }
}));
export const buildings = types.optional(BuildingsStore, {});